export const entityTypeEnum = Object.freeze({
  INDIVIDUAL: 'Individual',
  IRA: 'IRA',
  JOINT: 'Joint',
  CUSTODIAN: 'Custodian',
  SOLO401K: 'Solo401K',
  C_CORPORATION: 'C Corp',
  S_CORPORATION: 'S Corp',
  STATUTORY_BUSINESS_TRUST: 'Business Trust',
  LIMITED_LIABILITY_COMPANY_C_CORPORATION: 'LLC (C Corp)',
  LIMITED_LIABILITY_COMPANY_S_CORPORATION: 'LLC (S Corp)',
  LIMITED_LIABILITY_COMPANY_PARTNERSHIP: 'LLC (Partnership)',
  PERSONAL_TRUST: 'Personal Trust',
  TRADITIONAL_IRA: 'Traditional IRA',
  ROLLOVER_ACCOUNT: 'Rollover Account',
  BENEFICIARY_TRADITIONAL_IRA: 'Bene. Trad IRA',
  SEP: 'SEP',
  ROTH_IRA: 'Roth IRA',
  BENEFICIARY_ROTH_IRA: 'Bene. Roth IRA',
  SIMPLE_IRA_PARTICIPANT: 'Simple IRA',
})

export const iraTypeEnum = Object.freeze({
  TRADITIONAL_IRA: 'TRADITIONAL_IRA',
  ROLLOVER_ACCOUNT: 'ROLLOVER_ACCOUNT',
  BENEFICIARY_TRADITIONAL_IRA: 'BENEFICIARY_TRADITIONAL_IRA',
  SEP: 'SEP',
  ROTH_IRA: 'ROTH_IRA',
  BENEFICIARY_ROTH_IRA: 'BENEFICIARY_ROTH_IRA',
  SIMPLE_IRA_PARTICIPANT: 'SIMPLE_IRA_PARTICIPANT',
})

export const userAccountTypeEnum = Object.freeze({
  PERSONAL: 'PERSONAL',
  BUSINESS: 'BUSINESS',
  TRUST: 'TRUST',
  RETIREMENT: 'RETIREMENT',
  CUSTODIAL: 'CUSTODIAL',
  JOINT: 'JOINT',
})

export const userMemberTypeEnum = Object.freeze({
  MEMBER: 'MEMBER',
  NON_MEMBER: 'NON-MEMBER',
})

export const accountRequestStatusEnum = Object.freeze({
  BACK_OFFICE: 'BACK_OFFICE',
  READY_FOR_BACK_OFFICE: 'READY_FOR_BACK_OFFICE',
  INVESTIGATION_SUBMITTED: 'INVESTIGATION_SUBMITTED',
  PENDING: 'PENDING',
  SUSPENDED: 'SUSPENDED',
  ACTION_REQUIRED: 'ACTION_REQUIRED',
  COMPLETE: 'COMPLETE',
  VENDOR_REQUEST_SUBMITTED: 'VENDOR_REQUEST_SUBMITTED',
  REJECTED: 'REJECTED',
})

export const accountTypeToCustomerTypeMap = {
  [userAccountTypeEnum.BUSINESS]: [
    'STATUTORY_BUSINESS_TRUST',
    'LIMITED_LIABILITY_COMPANY_C_CORPORATION',
    'LIMITED_LIABILITY_COMPANY_S_CORPORATION',
    'LIMITED_LIABILITY_COMPANY_PARTNERSHIP',
    'C_CORPORATION',
    'S_CORPORATION',
  ],
  [userAccountTypeEnum.RETIREMENT]: [
    'TRADITIONAL_IRA',
    'SOLO401K',
    'ROLLOVER_ACCOUNT',
    'BENEFICIARY_TRADITIONAL_IRA',
    'SEP',
    'ROTH_IRA',
    'BENEFICIARY_ROTH_IRA',
  ],
  [userAccountTypeEnum.PERSONAL]: ['INDIVIDUAL'],
  [userAccountTypeEnum.TRUST]: ['PERSONAL_TRUST'],
  [userAccountTypeEnum.CUSTODIAL]: 'CUSTODIAN',
  [userAccountTypeEnum.JOINT]: [
    'JointRightsOfSurvivorship',
    'JointCommunityProperty',
    'JointTenantsByEntirety',
    'JointTenantsInCommon',
  ],
}
